export default "/assets/cd4f374e69987f56.png"